import { hasExternalReferrer } from './hasExternalReferrer';

export const sanitizeReferrer = (url = '') => (hasExternalReferrer(url) ? url.replace(/(^\w+:|^)\/\//, '') : '');
